function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ga, mixpanel } from '@domain-group/fe-co-allhomes-analytics';
var RATE_MY_AGENT = 'Ratemyagent Agent Profile';
var AGENT_PROFILE = 'Agent Profile';
var AGENT_PROFILE_HEADER = 'Agent Profile - Header';
var AGENT_PROFILE_MAP_CARD = 'Agent Profile - Map Card';
var AGENT_PROFILE_FLOATING_CTA = 'Agent Profile - Floating CTA';
var gaConversionCall = source => ga.conversion('Click to Reveal - Find an Agent', "Agent Profile - ".concat(source));
export default {
  'next-review': () => ga.interaction(RATE_MY_AGENT, 'Display Next Review'),
  'previous-review': () => ga.interaction(RATE_MY_AGENT, 'Display Previous Review'),
  'expand-review': () => ga.interaction(RATE_MY_AGENT, 'Expand Review'),
  'open-review-profile': () => ga.interaction(RATE_MY_AGENT, 'View Ratemyagent Page'),
  '/agent-articles.article-click/': () => ga.conversion('Editorial Showcase', 'Agent Profile - Article - Click'),
  // Agency logo
  'agent.agency-logo-click': () => ga.interaction(AGENT_PROFILE, 'Agency Logo Click - Header'),
  // Page view
  'page-view': (_key, data) => mixpanel.viewAgentProfile(data),
  // Enquiry form submitted
  'send-enquiry': (_key, _ref) => {
    var options = _ref.options;
    return _objectSpread(_objectSpread({}, ga.conversion('Email Enquiry - Find an Agent', 'Agent Profile')), mixpanel.emailEnquiry({
      enquiryReasons: options
    }));
  },
  // Call agent button
  'agent.call-reveal': () => _objectSpread(_objectSpread({}, gaConversionCall('Header')), mixpanel.revealPhone({
    enquiryCTA: AGENT_PROFILE_HEADER
  })),
  'footer.call-reveal': () => _objectSpread(_objectSpread({}, gaConversionCall('Footer')), mixpanel.revealPhone({
    enquiryCTA: AGENT_PROFILE_MAP_CARD
  })),
  'mobile-enquiry-cta.call-reveal': () => _objectSpread(_objectSpread({}, gaConversionCall('Footer')), mixpanel.revealPhone({
    enquiryCTA: AGENT_PROFILE_FLOATING_CTA
  })),
  // Email agent button
  'agent.email-click': () => _objectSpread(_objectSpread({}, ga.interaction(AGENT_PROFILE, 'Open Email Lightbox - Header')), mixpanel.displayContactAgentForm({
    enquiryCTA: AGENT_PROFILE_HEADER
  })),
  'footer.email-click': () => _objectSpread(_objectSpread({}, ga.interaction(AGENT_PROFILE, 'Open Email Lightbox - Footer')), mixpanel.displayContactAgentForm({
    enquiryCTA: AGENT_PROFILE_MAP_CARD
  })),
  'mobile-enquiry-cta.email-click': () => _objectSpread(_objectSpread({}, ga.interaction(AGENT_PROFILE, 'Open Email Lightbox - Footer')), mixpanel.displayContactAgentForm({
    enquiryCTA: AGENT_PROFILE_FLOATING_CTA
  })),
  // Social links
  'agent.social.website-click': () => ga.interaction(AGENT_PROFILE, 'Agency Website Click - Header'),
  // Expand agent's description
  'agent.expand-description': () => ga.interaction(AGENT_PROFILE, 'Expand About Agent'),
  // Play agent video
  'agent.video-click': () => ga.interaction(AGENT_PROFILE, 'Play Video'),
  // Map interaction
  'footer.map-interacted': () => ga.interaction(AGENT_PROFILE, 'Map Interaction')
};